export const handleRequestor = (data, success) => ({
  type: 'requestor',
  payload: data,
  successMessage: success,
});

export const handleRequestedFor = (data, success) => ({
  type: 'requestedFor',
  payload: data,
  successMessage: success,
});

export const handleAccountId = (data, success) => ({
  type: 'accountId',
  payload: data,
  successMessage: success,
});

export const handleJustification = (data, success) => ({
  type: 'businessJustification',
  payload: data,
  successMessage: success,
});

export const handleDateRange = (startDate, endDate, success) => ({
  type: 'dateRange',
  payload: { start: startDate, end: endDate },
  successMessage: success,
});
